<template>
  <div
    id="login"
    class="container">
    <div class="columns is-centered">
      <div class="column is-3 is-5-tablet is-4-desktop is-3-widescreen">
        <form
          class="box"
          @submit.prevent="handleSubmit">
          <b-field
            :label="$gettext('Användarnamn')">
            <b-input
              v-model="username"
              :placeholder="$gettext('Fyll i ditt användarnamn')" />
          </b-field>
          <b-field
            :label="$gettext('Lösenord')">
            <b-input
              v-model="password"
              type="password" />
          </b-field>
          <button
            class="button"
            :disabled="loggingIn">
            <translate>Logga In</translate>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: '',
      submitted: false
    }
  },
  computed: {
    loggingIn () {
      return this.$store.state.authentication.status.loggingIn;
    }
  },
  created () {
    // reset login status
    this.$store.dispatch('authentication/logout');
  },
  methods: {
    handleSubmit () {
      this.submitted = true;
      const { username, password } = this;
      const { dispatch } = this.$store;
      if (username && password) {
        dispatch('authentication/login', { username, password });
      }
    }
  }
};
</script>
<style scoped>
.columns, #login {
  margin: 20px;
  margin-bottom: 20px;
}
.columns:last-child {
  margin-bottom: 200px;
  height: 50vh;
}
</style>
